// extracted by mini-css-extract-plugin
export default {"chart-axis":"Axis_chart-axis__mymyy","chart-axis-ticks":"Axis_chart-axis-ticks__O5t30"};